<template>
  <div>
    <Status v-for="up in updates" :key="up.date" :date="up.date" :message="up.message"></Status>
  </div>
</template>

<script>
import Status from '@/components/Status'

export default {
  components: {
    Status
  },
  data: function () {
    return {
      updates: [
        {
          date: 'Vendredi 29/03/2019',
          message: `Je viens de faire une mise à jour de EXPLORE, l'accès à l'interface d'administration pouvait être bloqué en cas de mauvaise manip et nécessitait alors un enchainement d'opérations beaucoup trop complexes.


Désormais, l'interface d'admin s'affiche en faisant :
- 2 clics sur la tuile de titre
- puis 2 clics sur le QRCode ou sur la tuile d'image (pratique si il n'y a pas de QRCode)


N'oubliez pas de sortir du mode kiosk pour permettre l'apparition du clavier 🙂`
        },
        {
          date: 'Vendredi 23/03/2019',
          message: `Voici un résumé des avancées de cette semaine concernant EXPLORE.
- L'interface pour le hall a été activée à Part-Dieu et dans la bibliothèque du 2ème
- Désormais un avertissement est affiché dans la popup si l'événement est annulé
- L'écran d'accueil sur les tablettes est désormais animé, malgré tout mon soin apporté à ce changement, il augmente la consommation en énergie des tablettes, n'hésitez pas à me faire des retours si c'est trop énergivore !
- Tuile de présentation pour chaque partenaire de l'événement sur les tablettes
- Quelques ajustements graphiques de l'interface tablette

La semaine prochaine :
- Meilleure gestion des liens vers le catalogue
- Adaptation d'EXPLORE aux API de Dokk1
- Possibilité de programmer plusieurs événements sur une même tablette`
        },
        {
          date: 'Vendredi 15/03/2019',
          message: `Cette semaine de nombreux changements viennent améliorer EXPLORE.
+ La première version du prototype pour le hall
+ De nombreux ajustements graphiques de l'interface tablette
+ Créations de mini-tuiles indépendantes pour chaque lien externe (Tuiles Youtube, Mixcloud, soundcloud, Wikipedia, Influx, etc.) et permettant la lecture les contenus vidéos et audio directement dans l'interface.


La semaine prochaine :
+ Meilleure gestion des liens vers le catalogue
+ Animations de l'écran d'accueil
+ Tuile de présentation du partenaire de l'événement


Toutes les avancées sont consignées sur le site [https://explore-status.placed.eu/](https://explore-status.placed.eu/), avec notamment des captures d'écran récentes du rendu sur iPad et sur écran 43". Le site permet également de consulter les retours qui ont déjà été fait, et de soumettre de nouvelles suggestions.


Je ne peux que vous inviter à faire part de vos remarques, elles sont plus que bienvenues.`
        },
        {
          date: 'Jeudi 07/03/2019',
          message: `Entre l'installation des écrans tactiles dans les halls des bibliothèques de Part-Dieu et du 2ème ainsi que mon arrivée à Aarhus au Danemark, les évolutions et corrections sur EXPLORE se sont ralenties. Les principales avancées ont porté sur :

+ Le développement de l'interface pour le hall
+ L'amélioration de l'interface d'administration afin de permettre l'ajout de liens et le téléversement de fichiers
+ Une meilleure gestion des événements avec plusieurs dates
+ La corrections de divers bug d'affichage
+ Des commandes de câbles et batteries pour tenter de résoudre les problèmes d'alimentation des tablettes autonomes.

Le développement de l'interface pour le hall est ma principale priorité pour les jours qui viennent avec une première version testée et validée pour le milieu de la semaine prochaine.
Je retravaillerai ensuite le design des tuiles sur tablette, en ajoutant progressivement de nouvelles dédiées aux différents contenus, notamment pour la démo autour de l'événement Jaquette et Diamant #2.

Afin de centraliser le suivi du déploiement d'EXPLORE, j'ai mis en place un petit site web qui a pour ambition de regrouper les documents d'aide pour l'utilisation d'EXPLORE, mais aussi suivre les développements et de faire des suggestions.
C'est ici : [https://explore-status.placed.eu](https://explore-status.placed.eu)`
        },
        {
          date: 'Mercredi 06/03/2019',
          message: `Pour rappel, les événements configurés sont :
### Part Dieu
Société - [https://explore.placed.eu/#/3598](https://explore.placed.eu/#/3598) - De la femme au foyer bien éduquée à la Mad Woman

Civilisation - [https://explore.placed.eu/#/5214](https://explore.placed.eu/#/5214) - Faut-il avoir peur des robots ?

### 2e
Poésie - [https://explore.placed.eu/#/4969](https://explore.placed.eu/#/4969) - Poèmes horodateurs

Société - [https://explore.placed.eu/#/5036](https://explore.placed.eu/#/5036) - My Body Is Political

Jeunesse - [https://explore.placed.eu/#/3687](https://explore.placed.eu/#/3687) - Quelle Histoire !`
        },
        {
          date: 'Jeudi 21/02/2019',
          message: `Le déploiement et le développement du prototype EXPLORE avance. Les dernières versions permettent désormais de mettre à disposition des liens vers des sites web externes ou vers un panier du catalogue ainsi que des fichiers que les utilisateurs peuvent télécharger sur leurs dispositifs.

Les prochains développements sont des améliorations visuelles de la présentation des ressources vidéo, audio, fichiers, etc. Ainsi que l'ajout de dynamisme et d'animations sur divers éléments.

La maintenance des tablettes reste un point difficile, il s'avère qu'avec les batteries que nous avons fourni, la charge ne peut pas s'effectuer correctement pendant la nuit, de nouvelles, avec plus de capacité devraient bientôt arriver. Deux tablettes sur les trois déployées dans le 2e sont branchées sur le secteur.

Nous avons installé un premier grand écran tactile dans le hall de la bibliothèque du 2ème et nous pouvons envisager l'installation d'un deuxième écran dans les prochains jours à Part-dieu.`
        },
        {
          date: 'Lundi 11/02/2019',
          message: `Depuis maintenant 2 semaines, nous avons commencé à installer progressivement le prototype d'EXPLORE dans les départements Société et Civilisation.

Une première tablette est installée dans la bibliothèque éphémère et affiche des informations sur l'événement "Quand les technologies façonnent le corps" du cycle "Demain l'humain". La deuxième est installée à l'entrée de Société et communique sur les événements du cycle "La Fabrique de l'Info".

Nous travaillons encore à régler des problèmes d'alimentation et d'accès au réseau. Cela  devrait être réglé en début de semaine.

Mardi nous installons 3 tablettes dans la bibliothèque du 2ème centrées sur des événements Jeunesse, Poésie et Société.

Nous attendons encore la livraison des grands écrans tactiles ainsi que leurs supports pour pouvoir commencer à les déployer. Nous espérons commencer à partir de la semaine du 18/02.

Le prototype est en plein développement et est amené à vite changer, n'hésitez pas à faire des retours si vous en avez.

`
        }
      ]
    }
  }
}
</script>

